// EnterpriseGradeFeatures.jsx
import React from "react";
import styles from "./EnterpriseGradeFeatures.module.css";

const IconLatency = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a10 10 0 1 0 10 10" />
        <path d="M12 6v6l4 2" />
    </svg>
);

const IconEmotion = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
        <line x1="9" y1="9" x2="9.01" y2="9" />
        <line x1="15" y1="9" x2="15.01" y2="9" />
    </svg>
);

const IconLanguage = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 5h7" />
        <path d="M9 3v2c0 4-3 7-7 7" />
        <path d="M5 9c2 2 4 3 7 3" />
        <path d="M12 20l4-9 4 9" />
        <path d="M19 18h-6" />
    </svg>
);

const IconStream = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="2" />
        <path d="M16.24 7.76a6 6 0 0 1 0 8.49" />
        <path d="M7.76 7.76a6 6 0 0 0 0 8.49" />
    </svg>
);

const IconApi = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="16 18 22 12 16 6" />
        <polyline points="8 6 2 12 8 18" />
    </svg>
);

const IconSSML = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
    </svg>
);

const IconDictionary = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
        <path d="M4 4h16v16" />
    </svg>
);

const IconControl = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="4" y1="21" x2="4" y2="14" />
        <line x1="4" y1="10" x2="4" y2="3" />
        <line x1="12" y1="21" x2="12" y2="12" />
        <line x1="12" y1="8" x2="12" y2="3" />
        <line x1="20" y1="21" x2="20" y2="16" />
        <line x1="20" y1="12" x2="20" y2="3" />
    </svg>
);

const IconLock = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
);
const MicIcon = () => (
    <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
    >
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
        <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
        <line x1="12" y1="19" x2="12" y2="23" />
        <line x1="8" y1="23" x2="16" y2="23" />
    </svg>
);

const features = [
    { title: "Sub-100ms time-to-first-byte latency", desc: "Instant response for live conversations and interactive voice systems.", icon: <IconLatency /> },
    { title: "15+ emotional tones per voice", desc: "Control tone and intent without breaking natural speech flow.", icon: <IconEmotion /> },
    { title: "10+ languages with native accents", desc: "Global coverage with region-accurate pronunciation — not generic voices.", icon: <IconLanguage /> },
    { title: "Real-Time WebSocket Streaming", desc: "Low-latency audio streaming for voice agents and live interactions.", icon: <IconStream /> },
    { title: "REST API for Batch Processing", desc: "Generate large volumes of audio reliably and efficiently.", icon: <IconApi /> },
    { title: "SSML Support", desc: "Fine-grained control over pauses, emphasis, pronunciation, and delivery.", icon: <IconSSML /> },
    { title: "Custom Pronunciation Dictionaries", desc: "Enforce brand names, technical terms, and domain-specific vocabulary.", icon: <IconDictionary /> },
    { title: "Speed & Pitch Control", desc: "Tune voice delivery for different audiences and use cases.", icon: <IconControl /> },
    { title: "On-Premise Deployment Available", desc: "Full data control for regulated, security-sensitive environments.", icon: <IconLock /> },
];

export default function EnterpriseGradeFeatures() {
    return (
        <section className={styles.wrapper}>
            <h2 className={styles.heading}>Enterprise-Grade Features</h2>
            <p className={styles.subheading}>
                Built to operate at scale, under real production constraints.
            </p>

            <div className={styles.grid}>
                {features.map((item, i) => (
                    <div key={i} className={styles.card}>
                        <div className={styles.icon}>{item.icon}</div>
                        <h3>{item.title}</h3>
                        <p>{item.desc}</p>
                    </div>
                ))}
            </div>

            <div className={styles.ctaSection}>
                <h2>Stop Typing. Start Speaking.</h2>
                <p>
                    Let ToxBox AI handle transcription so you can focus on actual work.
                </p>
                <button className={styles.ctaBtn}>
                    <MicIcon />
                    <span>Start Speech-to-Text Now</span>
                    <span className={styles.arrow}>→</span>
                </button>
                <span className={styles.note}>
                    No credit card required. Start transcribing in seconds.
                </span>
            </div>
        </section>
    );
}
